// TR illeri + örnek lat/lng (il merkezleri yaklaşık değerlerdir)
export const TR_CITIES = [
  { name: 'Adana', lat: 37.0000, lon: 35.3213 },
  { name: 'Adıyaman', lat: 37.7648, lon: 38.2786 },
  { name: 'Afyonkarahisar', lat: 38.7507, lon: 30.5567 },
  { name: 'Ağrı', lat: 39.7191, lon: 43.0503 },
  { name: 'Aksaray', lat: 38.3687, lon: 34.0370 },
  { name: 'Amasya', lat: 40.6499, lon: 35.8353 },
  { name: 'Ankara', lat: 39.9334, lon: 32.8597 },
  { name: 'Antalya', lat: 36.8841, lon: 30.7056 },
  { name: 'Ardahan', lat: 41.1105, lon: 42.7022 },
  { name: 'Artvin', lat: 41.1828, lon: 41.8183 },
  { name: 'Aydın', lat: 37.8444, lon: 27.8458 },
  { name: 'Balıkesir', lat: 39.6484, lon: 27.8826 },
  { name: 'Bartın', lat: 41.6358, lon: 32.3375 },
  { name: 'Batman', lat: 37.8812, lon: 41.1351 },
  { name: 'Bayburt', lat: 40.2552, lon: 40.2249 },
  { name: 'Bilecik', lat: 40.0567, lon: 30.0665 },
  { name: 'Bingöl', lat: 38.8845, lon: 40.4980 },
  { name: 'Bitlis', lat: 38.4012, lon: 42.1078 },
  { name: 'Bolu', lat: 40.7325, lon: 31.6080 },
  { name: 'Burdur', lat: 37.7204, lon: 30.2900 },
  { name: 'Bursa', lat: 40.1828, lon: 29.0665 },
  { name: 'Çanakkale', lat: 40.1553, lon: 26.4142 },
  { name: 'Çankırı', lat: 40.6013, lon: 33.6134 },
  { name: 'Çorum', lat: 40.5499, lon: 34.9550 },
  { name: 'Denizli', lat: 37.7765, lon: 29.0864 },
  { name: 'Diyarbakır', lat: 37.9144, lon: 40.2306 },
  { name: 'Düzce', lat: 40.8438, lon: 31.1565 },
  { name: 'Edirne', lat: 41.6818, lon: 26.5623 },
  { name: 'Elazığ', lat: 38.6810, lon: 39.2264 },
  { name: 'Erzincan', lat: 39.7460, lon: 39.4914 },
  { name: 'Erzurum', lat: 39.9043, lon: 41.2679 },
  { name: 'Eskişehir', lat: 39.7767, lon: 30.5206 },
  { name: 'Gaziantep', lat: 37.0662, lon: 37.3833 },
  { name: 'Giresun', lat: 40.9128, lon: 38.3895 },
  { name: 'Gümüşhane', lat: 40.4602, lon: 39.4814 },
  { name: 'Hakkari', lat: 37.5744, lon: 43.7408 },
  { name: 'Hatay', lat: 36.4018, lon: 36.3498 },
  { name: 'Iğdır', lat: 39.9237, lon: 44.0450 },
  { name: 'Isparta', lat: 37.7648, lon: 30.5566 },
  { name: 'İstanbul', lat: 41.0082, lon: 28.9784 },
  { name: 'İzmir', lat: 38.4192, lon: 27.1287 },
  { name: 'Kahramanmaraş', lat: 37.5858, lon: 36.9371 },
  { name: 'Karabük', lat: 41.2061, lon: 32.6204 },
  { name: 'Karaman', lat: 37.1759, lon: 33.2287 },
  { name: 'Kars', lat: 40.6013, lon: 43.0975 },
  { name: 'Kastamonu', lat: 41.3887, lon: 33.7827 },
  { name: 'Kayseri', lat: 38.7312, lon: 35.4787 },
  { name: 'Kırıkkale', lat: 39.8468, lon: 33.5153 },
  { name: 'Kırklareli', lat: 41.7333, lon: 27.2167 },
  { name: 'Kırşehir', lat: 39.1425, lon: 34.1709 },
  { name: 'Kilis', lat: 36.7184, lon: 37.1212 },
  { name: 'Kocaeli', lat: 40.8533, lon: 29.8815 },
  { name: 'Konya', lat: 37.8746, lon: 32.4932 },
  { name: 'Kütahya', lat: 39.4242, lon: 29.9833 },
  { name: 'Malatya', lat: 38.3552, lon: 38.3095 },
  { name: 'Manisa', lat: 38.6191, lon: 27.4289 },
  { name: 'Mardin', lat: 37.3212, lon: 40.7245 },
  { name: 'Mersin', lat: 36.8000, lon: 34.6333 },
  { name: 'Muğla', lat: 37.2153, lon: 28.3636 },
  { name: 'Muş', lat: 38.7432, lon: 41.5065 },
  { name: 'Nevşehir', lat: 38.6939, lon: 34.6857 },
  { name: 'Niğde', lat: 37.9667, lon: 34.6833 },
  { name: 'Ordu', lat: 40.9839, lon: 37.8764 },
  { name: 'Osmaniye', lat: 37.0742, lon: 36.2467 },
  { name: 'Rize', lat: 41.0201, lon: 40.5234 },
  { name: 'Sakarya', lat: 40.7889, lon: 30.4060 },
  { name: 'Samsun', lat: 41.2867, lon: 36.3300 },
  { name: 'Siirt', lat: 37.9333, lon: 41.9500 },
  { name: 'Sinop', lat: 42.0231, lon: 35.1531 },
  { name: 'Sivas', lat: 39.7477, lon: 37.0179 },
  { name: 'Şanlıurfa', lat: 37.1591, lon: 38.7969 },
  { name: 'Şırnak', lat: 37.5164, lon: 42.4611 },
  { name: 'Tekirdağ', lat: 40.9833, lon: 27.5167 },
  { name: 'Tokat', lat: 40.3167, lon: 36.5500 },
  { name: 'Trabzon', lat: 41.0015, lon: 39.7178 },
  { name: 'Tunceli', lat: 39.1079, lon: 39.5401 },
  { name: 'Uşak', lat: 38.6823, lon: 29.4082 },
  { name: 'Van', lat: 38.4942, lon: 43.3800 },
  { name: 'Yalova', lat: 40.6500, lon: 29.2667 },
  { name: 'Yozgat', lat: 39.8181, lon: 34.8147 },
  { name: 'Zonguldak', lat: 41.4564, lon: 31.7987 },
];
